import { ContentService } from '@blk/cwp-ng-framework';
import { AbstractRenderer, BusinessComponent, BusinessComponentOptions, StaticParagraphComponent } from '@blk/simba';
import { CellUtil, ComponentData, TabData, TabUtil } from '@ddt-web/data-service';
import { DisclosureComponent, HeadingComponent, HeadingLevel } from '@ddt-web/pdf-components';
import * as get from 'lodash/get';

export class PerformanceCommentaryComponent extends BusinessComponent {
	constructor(
		name: string,
		public dataComponentId: string,
		public includePerformance: boolean = true,
		public visible: boolean = true
	) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible, componentId: dataComponentId }));
	}

	public isComponentDataVisible(componentData: ComponentData): boolean {
		const tabData: TabData = componentData.getTabById('family.performance.commentary');
		return componentData && componentData.success && TabUtil.isTabValid(tabData) && this.includePerformance;
	}

	public buildComponent(componentData: ComponentData, contentSvc: ContentService): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];

		if (this.isComponentDataVisible(componentData)) {
			const cells = get(componentData.getTabById('family.performance.commentary'), 'tableData[0].cells[0]', []);
			const commentaryDcr = get(CellUtil.getById(cells, 'commentaryTypeRef'), 'rawValue');
			const commentaryValue = contentSvc.get(commentaryDcr + '_PERFORMANCE', 'Performance commentary is not available for this model family');
			const commentaryDcrKeyPdfOverride = commentaryDcr + '_PDF';
			const commentaryPanel = new StaticParagraphComponent(commentaryDcrKeyPdfOverride, commentaryValue, {}, { marginBottom: 8 });

			panels.push(new HeadingComponent('PDF_PERFORMANCE_COMMENTARY_H1', 'PERFORMANCE COMMENTARY', HeadingLevel.H1));
			panels.push(commentaryPanel);
			panels.push(new DisclosureComponent(
				'PDF_PERFORMANCE_COMMENTARY_DISCLOSURE', 'PDF_PERFORMANCE_COMMENTARY_DISCLOSURE', {}, { paddingTop: 15, paddingBottom: 20 })
			);
		}

		return panels;
	}
}
